import { getApiClient } from '@plandi/common'
import { components } from '@plandi/common/src/generated'

import {
  ProjectsUser,
  QueryParamsGetMeProjects,
  QueryParamsProjects,
  QueryParamsProjectsByUserId,
  QueryParamsProjectsFavorites
} from './projects.types'

export const modelsApi = {
  saveDraftProject: (
    requestBody: components['schemas']['MarketProjectRequest'],
    locale: string
  ) =>
    getApiClient(locale)
      .post('v1/market/models/feet', requestBody)
      .then(({ data }) => data),

  getProjectCategories: (locale: string) =>
    getApiClient(locale)
      .get<{ data: components['schemas']['ProjectMarketCategoryResource'][] }>(
        'v1/market/projects/categories'
      )
      .then(({ data }) => data.data),

  getProjectParts: (locale: string) =>
    getApiClient(locale)
      .get<{ data: components['schemas']['ProjectMarketPartResource'][] }>(
        'v1/market/projects/parts'
      )
      .then(({ data }) => data.data),

  getProjectsMe: (locale: string, params?: QueryParamsGetMeProjects) =>
    getApiClient(locale)
      .get<{
        data: components['schemas']['ProjectMarketMeResource'][]
      }>('v1/market/projects/me', { params })
      .then(({ data }) => data.data),

  getProjectMeById: (projectId: number, locale: string) =>
    getApiClient(locale)
      .get<{ data: components['schemas']['ProjectMarketResource'] }>(
        `v1/market/projects/me/${projectId}`
      )
      .then(({ data }) => data.data),

  updateProject: (
    projectId: number,
    requestBody: components['schemas']['MarketProjectRequest'],
    locale: string
  ) =>
    getApiClient(locale)
      .put(`v1/market/projects/${projectId}`, requestBody)
      .then(({ data }) => data),

  draftProject: (projectId: number, locale: string) =>
    getApiClient(locale)
      .put(`v1/market/projects/${projectId}/draft`)
      .then(({ data }) => data),

  publishProject: (projectId: number, locale: string) =>
    getApiClient(locale)
      .put(`v1/market/projects/${projectId}/published`)
      .then(({ data }) => data),

  getProjects: (locale: string, params?: QueryParamsProjects) =>
    getApiClient(locale)
      .get<{
        data: components['schemas']['ProjectMarketGetResource'][]
      }>('v1/market/projects', { params })
      .then(({ data }) => data.data),

  getProjectById: (projectId: number, locale: string) =>
    getApiClient(locale)
      .get<{
        data: components['schemas']['ModelMarketGetByIdResource']
      }>(`v1/market/projects/${projectId}`)
      .then(({ data }) => data.data),

  addFavorite: (projectId: number, locale: string) =>
    getApiClient(locale)
      .post(`v1/market/projects/${projectId}/favorite`)
      .then(({ data }) => data),

  deleteFavorite: (projectId: number, locale: string) =>
    getApiClient(locale)
      .delete(`v1/market/projects/${projectId}/favorite`)
      .then(({ data }) => data),

  getProjectsFavorites: (
    locale: string,
    params?: QueryParamsProjectsFavorites
  ) =>
    getApiClient(locale)
      .get<{ data: components['schemas']['ProjectMarketGetResource'][] }>(
        'v1/market/projects/favorites',
        { params }
      )
      .then(({ data }) => data.data),

  getProjectsByUserId: (
    userId: number,
    locale: string,
    params?: QueryParamsProjectsByUserId
  ) =>
    getApiClient(locale)
      .get<{ data: ProjectsUser }>(`v1/market/projects/users/${userId}`, {
        params
      })
      .then(({ data }) => data.data),

  getProjectChatMessagesByChatId: (chatId: number, locale: string) =>
    getApiClient(locale)
      .get<{ data: components['schemas']['ChatMessageListResource']['data'] }>(
        `v1/market/projects/chats/${chatId}/messages`
      )
      .then(({ data }) => data.data),

  createChatProject: (projectId: number, locale: string) =>
    getApiClient(locale)
      .post<{ data: { id?: number } }>(`v1/market/projects/${projectId}/chats`)
      .then(({ data }) => data.data),

  sendMessageProjectChat: (
    chatId: number,
    requestBody: components['schemas']['SendMessageRequest'],
    locale: string
  ) =>
    getApiClient(locale)
      .post(`v1/market/projects/chats/${chatId}/messages`, requestBody)
      .then(({ data }) => data),

  getProjectChats: (projectId: number, locale: string) =>
    getApiClient(locale)
      .get<{ data: components['schemas']['ChatListResource']['data'] }>(
        `v1/market/projects/${projectId}/chats`
      )
      .then(({ data }) => data.data),

  deleteProject: (projectId: number, locale: string) =>
    getApiClient(locale)
      .delete(`v1/market/projects/${projectId}`)
      .then(({ data }) => data),

  getChatsMe: (locale: string) =>
    getApiClient(locale)
      .get<{ data: components['schemas']['MyChatResource'][] }>(
        'v1/market/projects/chats'
      )
      .then(({ data }) => data.data)
}
